import './LiveCameraHelp.css';
import { getCurrentOrigin } from '../utils/cameraSupport';

export default function LiveCameraHelp({ onUseCaptureFallback }) {
  const origin = getCurrentOrigin();

  return (
    <div className="card live-camera-help stack">
      <h3 style={{ margin: 0 }}>เปิด Live Camera บน HTTP</h3>
      <p className="muted" style={{ margin: 0 }}>
        เบราว์เซอร์บล็อกกล้องสดบน <code>{origin || 'http://IP:5173'}</code> โดยค่าเริ่มต้น
        ต้องอนุญาต origin นี้ใน Chrome ก่อน (ทำครั้งเดียว)
      </p>
      <ol className="help-steps">
        <li>เปิด Chrome บนมือถือ → พิมพ์ <code>chrome://flags</code></li>
        <li>
          ค้นหา <strong>Insecure origins treated as secure</strong>
        </li>
        <li>
          ใส่ URL นี้ (คัดลอกทั้งบรรทัด):
          <div className="origin-box">{origin || 'http://192.168.x.x:5173'}</div>
        </li>
        <li>กด Relaunch → เปิดหน้านี้ใหม่ → กด「ลองเปิดกล้องอีกครั้ง」</li>
      </ol>
      <div className="row">
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
          ลองเปิดกล้องอีกครั้ง
        </button>
        <button type="button" className="btn" onClick={onUseCaptureFallback}>
          ใช้โหมดถ่ายภาพแทน
        </button>
      </div>
    </div>
  );
}
